<template>
  <div id="appWrapper">
    <v-app>
      <Header/>
      <v-fade-transition>
        <v-card class="news-info" v-if="this.getHeaderVisibility && this.isLogged && this.newsAvailable" @click="goToNews">
          <span>Es sind Neuigkeiten verfügbar.</span>
          <chevron_right/>
        </v-card>
      </v-fade-transition>
      <div v-if="getHeaderVisibility" class="headerCircleContainer" id="headerCircle">
        <div class="headerCircle">
        </div>
        <p class="headerText textSize__22" v-html="this.$store.state.headerText"></p>
        <swipe-menu v-if="this.isLogged && swipeVisible" class="swipeMenuWrapper"/>
      </div>

      <v-overlay class="loadingOverlay" v-if="overlayVisible" :key="this.getOverlayContent">
        <v-card class="loadingCard" v-if="getOverlayContent === 'waiting'">
          <v-card-title class="text--black textSize__16">
            Deine Bestellung wird verarbeitet
          </v-card-title>

          <v-card-text>
            <v-progress-circular
                indeterminate
                color="red"
            />
          </v-card-text>
        </v-card>

        <v-card class="loadingCard" v-if="getOverlayContent === 'success'">
          <v-card-title class="text--black textSize__16">
            Bestellung erfolgreich versandt.
          </v-card-title>

          <v-card-text>
            <v-icon color="success">
              mdi-check-circle
            </v-icon>
          </v-card-text>
        </v-card>

        <v-card class="loadingCard" v-if="getOverlayContent === 'mhd_control_list'">
            <v-card-title class="text--black textSize__16">
                MHD-Kontroll-Liste wird erstellt und versendet.
            </v-card-title>

            <v-card-text>
                <v-progress-circular
                        indeterminate
                        color="red"
                />
            </v-card-text>
        </v-card>
        <v-card class="loadingCard" v-if="getOverlayContent === 'mhd_control_list_error'">
            <v-card-title class="text--black textSize__16">
                Beim Erstellen der MHD-Kontroll-Liste ist ein Fehler aufgetreten.
            </v-card-title>

        </v-card>
      </v-overlay>


      <v-overlay class="loadingOverlay" v-if="depositOverlayVisible" :key="this.getDepositOverlayContent">
        <v-card class="loadingCard" v-if="this.getDepositOverlayContent === 'waiting'">
          <v-card-title class="text--black textSize__16">
            Die Pfandrückgabe wird verarbeitet
          </v-card-title>

          <v-card-text>
            <v-progress-circular
                indeterminate
                color="red"
            />
          </v-card-text>
        </v-card>

        <v-card class="loadingCard" v-if="this.getDepositOverlayContent === 'success'">
          <v-card-title class="text--black textSize__16">
            Die Pfandrückgabe wurde erfolgreich versandt
          </v-card-title>

          <v-card-text>
            <v-icon color="success">
              mdi-check-circle
            </v-icon>
          </v-card-text>
        </v-card>
      </v-overlay>


      <v-overlay class="loadingOverlay" :value="loadingOverlayTourData" style="z-index: 1000;">
        <v-card class="loadingCard">
          <v-card-title class="text--black textSize__16">
            {{ requestStateTourData === 'timeout' ? 'Zeitüberschreitung der Anforderung.\nBitte später erneut versuchen.' : requestPendingTourData ? 'Der Auftrag wird verarbeitet.' : 'Der Auftrag wurde erfolgreich versandt.'}}
          </v-card-title>

          <v-card-text>
            <v-progress-circular
              indeterminate
              color="red"
              v-if="requestPendingTourData"
            />
            <v-icon color="success" v-if="!requestPendingTourData && requestStateTourData === 'success'">
              mdi-check-circle
            </v-icon>
          </v-card-text>
        </v-card>
      </v-overlay>

      <v-main>
        <router-view/>
      </v-main>

      <bottom-navigation v-if="this.isLogged && this.getUserRole !== 2 && this.$router.currentRoute.name !=='setPassword'"/>
    </v-app>
    <vue-headful title="Grafgruppe - Onlineshop"/>
  </div>
</template>

<style>
  @import './assets/igros.scss';
  @import './assets/icons.scss';

</style>
<script>
import Header from "@/app/global/header";
import SwipeMenu from "@/app/global/swipeMenu";
import { mapGetters, mapActions, mapState } from "vuex";
import BottomNavigation from "@/app/global/bottomNavigation";
import chevron_right from "@/assets/chevron/chevron_right";
import router from "@/router";

export default {
  components: {chevron_right, BottomNavigation, SwipeMenu, Header},

  data:() => {
    return {
      swipeVisible: false,
      isIntersecting: false,
    }
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
    }),

    goToNews() {
      router.push({name: 'News'})
    }

  },

  computed: {
    ...mapGetters({
      getHeaderVisibility: 'getHeaderVisibility',
      overlayVisible: 'getOverlayVisibility',
      depositOverlayVisible: 'getDepositOverlayVisibility',
      getOverlayContent: 'getOverlayContent',
      getCartContentVisibility: 'getCartContentVisibility',
      getDepositOverlayContent: 'getDepositOverlayContent',
      getUserRole: 'getUserRole',
      isLogged: 'isLogged',
      newsAvailable: 'newsAvailable',
      getCurrentActiveMode: 'getCurrentActiveMode'
    }),
    ...mapState({
      requestStateTourData: 'requestStateTourData',
      requestPendingTourData: 'requestPendingTourData',
      loadingOverlayTourData: 'loadingOverlayTourData'
    })
  },

  watch: {
    $route(to, from){
      if(to !== from && to.path === '/shop' || to.name ==='Login'){
        this.setHeaderVisibility(true)
      }
      else {
        this.setHeaderVisibility(false)
      }
    },

    isLogged: {
      handler(role) {
        if(role) {
          if(this.getUserRole === '2') {
            this.swipeVisible = false
          }
          else {
            this.swipeVisible = true
          }
        }
      }
    }
  }
}
</script>

<style>
.loadingCard {
  transform: translateY(100%);
  height: 30vh;
  width: 100%;
  padding: 15%;
}

.loadingOverlay > .v-overlay__content {
  width: 92%;
}

.loadingCard.theme--dark.v-card {
  background-color: white!important;
}
</style>
